import { MultiSelectOption } from 'ui-components/multi-select/types';
import { CITY_TOWN_VILLAGE_GROUP, RegionTypes } from 'features/explore/model/map/types';
export type SectionValues = {
    marketValue?: string;
    regionValue?: string;
    name?: string;
    key: string;
};

export type Market_region_multiselect_tree = Pick<MultiSelectOption, 'name' | 'value'> & {
    subOptions?: SectionValues[];
    sectionValues?: SectionValues;
    key: string;
};

export const ZCTA_VALUE = 'zcta';
export const COUNTY_VALUE = 'county_group';
export const CITY_VALUE = 'city';
export const SUBMARKET_VALUE = 'submarket';

export const MARKET_SECTION_VALUES_BY_LAYERS_IDS: Record<RegionTypes, SectionValues> = {
    STATE: { key: 'state', marketValue: 'State (Market)', regionValue: 'State' },
    DMA: { key: 'dma', name: 'DMA', marketValue: 'DMA (Market)' },
    CBSA: { key: 'cbsa', name: 'CBSA', marketValue: 'CBSA (Market)' },
    COUNTY: {
        key: 'county',
        name: 'County',
        marketValue: 'County (Market)',
        regionValue: 'County',
    },
    CITIES: { key: CITY_VALUE, name: 'City', marketValue: 'City (Market)', regionValue: 'City' },
    TOWN: { key: 'town', name: 'Town', marketValue: 'Town (Market)', regionValue: 'Town' },
    VILLAGE: {
        key: 'village',
        name: 'Village',
        marketValue: 'Village (Market)',
        regionValue: 'Village',
    },
    PUMA: { key: 'puma', name: 'PUMA', marketValue: 'PUMA (Market)' },
    DOWNTOWN: { key: 'downtown', name: 'Downtown', marketValue: 'Downtown (Market)' },
    ZCTA: { key: ZCTA_VALUE, name: 'ZCTA', marketValue: 'ZCTA (Market)' },
    CBG: {
        key: 'cbg',
        name: 'Census Block Group',
        marketValue: 'Census Block Group (Market)',
    },
    NEIGHBORHOOD: {
        key: 'neighborhood',
        name: 'Neighborhood',
        marketValue: 'Neighborhood (Market)',
        regionValue: 'Neighborhood',
    },
    RESIDENTIAL: {
        key: 'residential',
        name: 'Residential',
        marketValue: 'Residential',
    },
    DISTRICT: { key: 'district', name: 'District', marketValue: 'District (Market)' },
    OFFICE: { key: 'office', name: 'Office', marketValue: 'Office (Market)' },
    RETAIL: { key: 'retail', name: 'Retail', marketValue: 'Retail (Market)' },
    INDUSTRIAL: { key: 'industrial', name: 'Industrial', marketValue: 'Industrial (Market)' },
    MARKET: { key: 'market', name: 'Market', marketValue: 'Market' },
    BID: {
        key: 'BID',
        name: 'Business Improvement District',
        marketValue: 'Business Improvement District (Market)',
    },
    COMMERCIAL_DISTRICT: {
        key: 'COMMERCIAL_DISTRICT',
        name: 'Commercial District',
        marketValue: 'Commercial District (Market)',
    },
    UA: { key: 'ua', name: 'Urban Area', marketValue: 'Urban Area (Market)' },
};

export const MARKET_REGION_MULTISELECT_TREE: Market_region_multiselect_tree[] = [
    {
        key: 'state_group',
        name: 'State',
        value: 'State',
        sectionValues: MARKET_SECTION_VALUES_BY_LAYERS_IDS.STATE,
    },
    {
        key: 'dma_group',
        name: 'DMA',
        value: 'DMA',
        sectionValues: MARKET_SECTION_VALUES_BY_LAYERS_IDS.DMA,
    },
    {
        key: 'cbsa_group',
        name: 'CBSA',
        value: 'CBSA',
        sectionValues: MARKET_SECTION_VALUES_BY_LAYERS_IDS.CBSA,
    },
    {
        key: COUNTY_VALUE,
        name: 'County',
        value: 'County',
        sectionValues: MARKET_SECTION_VALUES_BY_LAYERS_IDS.COUNTY,
    },
    {
        key: CITY_TOWN_VILLAGE_GROUP,
        name: CITY_TOWN_VILLAGE_GROUP,
        value: CITY_TOWN_VILLAGE_GROUP,
        subOptions: [
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.CITIES,
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.TOWN,
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.VILLAGE,
        ],
    },
    {
        key: 'submarket_group',
        name: 'Submarket',
        value: 'Submarket',
        subOptions: [
            {
                key: SUBMARKET_VALUE,
                name: 'Submarket',
                marketValue: 'Submarket (Market)',
                regionValue: 'Submarket',
            },
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.OFFICE,
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.RETAIL,
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.INDUSTRIAL,
        ],
    },
    {
        key: 'puma_group',
        name: 'PUMA',
        value: 'PUMA',
        sectionValues: MARKET_SECTION_VALUES_BY_LAYERS_IDS.PUMA,
    },
    {
        key: 'retail_node_group',
        name: 'Retail Node',
        value: 'Retail Node',
        sectionValues: {
            key: 'retail_node',
            name: 'Retail Node',
            regionValue: 'Retail Node',
        },
    },
    {
        key: 'shopping_district_group',
        name: 'Shopping District',
        value: 'Shopping District',
        sectionValues: {
            key: 'shopping_district',
            name: 'Shopping District',
            regionValue: 'Shopping District',
        },
    },
    {
        key: 'district_group',
        name: 'District',
        value: 'District',
        subOptions: [
            {
                key: 'business_imprv_district',
                name: 'Business Improvement District',
                marketValue: 'Business Improvement District (Market)',
            },
            { key: 'downtown', name: 'Downtown', marketValue: 'Downtown (Market)' },
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.DISTRICT,
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.COMMERCIAL_DISTRICT,
            MARKET_SECTION_VALUES_BY_LAYERS_IDS.NEIGHBORHOOD,
        ],
    },
    {
        key: 'ZCTA_group',
        name: 'Zip Code',
        value: 'Zip Code',
        subOptions: [MARKET_SECTION_VALUES_BY_LAYERS_IDS.ZCTA],
    },
    {
        key: 'region_group',
        name: 'Region',
        value: 'Region',
        subOptions: [
            { key: 'census_block', name: 'Census Block', regionValue: 'Census Block' },
            { key: 'address', name: 'Address', regionValue: 'Address' },
            { key: 'island', name: 'Island', regionValue: 'Island' },
            { key: 'country', name: 'Country', regionValue: 'Country' },
            {
                key: 'states_municipalities',
                name: 'States & Municipalities',
                regionValue: 'States & Municipalities',
            },
            {
                key: 'region',
                name: 'Region',
                regionValue: 'Region',
                marketValue: 'Region (Market)',
            },
        ],
    },
    {
        key: 'cbg_group',
        name: 'Census Block Group',
        value: 'Census Block Group',
        sectionValues: MARKET_SECTION_VALUES_BY_LAYERS_IDS.CBG,
    },
    {
        key: 'BID',
        name: 'Business Improvement District',
        value: 'Business Improvement District',
        sectionValues: MARKET_SECTION_VALUES_BY_LAYERS_IDS.BID,
    },
];
